<template>
    <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled v-if="checkPermission">
      <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i :class="icon"></i> {{name}}</div>
      <ul class="nav-dropdown-items">
        <slot></slot>
      </ul>
    </router-link>
</template>
<script>
  export default {
    props: {
      name: {
        type: String,
        default: ''
      },
      url: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      permission: {
        type: [String, Array],
        default: ''
      }
    },
    computed: {
      checkPermission () {
        if (this.permission === '' || this.permission.length === 0) {
          return true
        }
        return this.hasPermission(this.permission)
      }
    },
    methods: {
      handleClick (e) {
        e.preventDefault()
        e.target.parentElement.classList.toggle('open')
      },
      resolve (path, obj) {
        return path.split('.').reduce(function (prev, curr) {
          return prev ? prev[curr] : undefined
        }, obj || self)
      }

    }
  }
</script>
